import React from "react";

import Container from "../Container";
import RichtextRenderer from "../RichtextRenderer";
import Button from "../basic/Button";

// import LinkArrow from "../../assets/arrow_right_1.svg";

const LeftDirection = ({ videoLink, title, text, buttonLabel, buttonLink, videoTitle, videoSubtitle }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-64px">
      <iframe
        className="shrink w-full h-201px md:h-460px"
        title="Interview with CEO"
        src={
          videoLink.includes("https://www.youtube.com/embed/")
            ? videoLink.replace("youtube", "youtube-nocookie")
            : videoLink
        }
      />
      <div className="bg-white w-full">
        <div className="h-full flex flex-col">
          <h2 className="text-gold text-32px leading-10 font-[Montserrat]">{title}</h2>
          <h3 className="text-24px font-bold leading-8 font-lato">{videoSubtitle}</h3>
          <div>
            <RichtextRenderer data={text} />
          </div>
          <div>
            <Button
              variant="white-blue"
              className="flex items-center gap-10px rounded-none !w-fit !py-0"
              px="px-27px"
              buttonClassName="!py-0"
              link={buttonLink}
              arrow
            >
              {buttonLabel}
              {/*<img src={LinkArrow} alt="Link Arrow" className="w-55px h-34px shrink-0" />*/}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

const RightDirection = ({ videoLink, text, buttonLabel, buttonLink, videoTitle, videoSubtitle }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-64px">
      <div className="bg-white w-full order-2 md:order-1">
        <div className="h-full flex flex-col">
          <h2 className="text-gold">{videoTitle}</h2>
          <h3>{videoSubtitle}</h3>
          <div>
            <RichtextRenderer data={text} />
          </div>
          <div>
            <Button
              variant="white-blue"
              className="flex items-center gap-10px rounded-none !w-fit !py-0"
              px="px-27px"
              buttonClassName="!py-0"
              link={buttonLink}
              arrow
            >
              {buttonLabel}
              {/*<img*/}
              {/*  src={LinkArrow}*/}
              {/*  alt="Link Arrow"*/}
              {/*  className="w-55px h-34px shrink-0"*/}
              {/*/>*/}
            </Button>
          </div>
        </div>
      </div>
      <iframe
        className="shrink w-full h-201px md:h-460px order-1 md:order-2"
        id="business-model-frame"
        title="Interview with CEO"
        src={
          videoLink.includes("https://www.youtube.com/embed/")
            ? videoLink.replace("youtube", "youtube-nocookie")
            : videoLink
        }
      />
    </div>
  );
};

const VideoSection = ({ direction, id, ...props }) => {
  return (
    <Container innerContainerClassName="relative bg-white" additionalPx id={id}>
      {direction === "left" ? <LeftDirection {...props} /> : <RightDirection {...props} />}
    </Container>
  );
};

export default VideoSection;
